import React from "react";

const WhyChooseUs: React.FC = () => {
  const chipsLeft = [
    "Sell what's trendy",
    "Unclear timelines",
    "Hidden costs",
    "Slow delivery",
  ];

  const chipsRight = [
    "Build what matters",
    "Done with you",
    "Transparent process",
    "Real results",
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#f7f1e8]">
      <div className="max-w-6xl mx-auto text-center space-y-4">
        <h2 className="text-4xl md:text-5xl font-light text-[#2f2117] leading-tight">
          We're not your <span className="text-[#a18976]">typical</span> AI agency.
        </h2>
        <p className="text-base text-[#6f5c4f] max-w-3xl mx-auto leading-relaxed">
          We skip the buzzwords and experimental projects. We focus on clear communication, fast delivery, and systems your team can use on day one.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-6 text-left items-stretch">
          {/* Other agencies */}
          <div className="rounded-3xl overflow-hidden shadow-lg bg-gradient-to-br from-[#0f172a] via-[#0b1220] to-[#090c16] relative min-h-[260px] flex flex-col">
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
            <div className="relative px-10 pt-8 pb-10 flex flex-col gap-6 flex-1">
              <div className="flex flex-wrap gap-2 justify-center">
                {chipsLeft.map((chip, idx) => (
                  <span
                    key={idx}
                    className="text-xs text-[#d6dbe3] bg-white/5 border border-white/15 px-3 py-1 rounded-lg tracking-tight"
                  >
                    {chip}
                  </span>
                ))}
              </div>
              <div className="flex-1 flex flex-col items-center gap-4">
                <h3 className="text-white text-4xl md:text-5xl font-light leading-tight text-center">
                  Other agencies
                </h3>
                <p className="text-[#d5d9df] text-base leading-relaxed text-center">
                  Overwhelm you with buzzwords, take months to deliver, and leave you with tools you can't use.
                </p>
                <div className="w-full flex justify-center">
                  <ul className="text-sm text-[#c4c9d2] space-y-1.5 text-left max-w-sm">
                    <li>• Vague timelines and shifting scopes</li>
                    <li>• Hidden costs and unclear ownership</li>
                    <li>• Complex handoffs, minimal support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Bear Strategy Lab */}
          <div
            className="rounded-3xl overflow-hidden shadow-lg relative min-h-[260px] flex flex-col"
            style={{
              backgroundImage:
                "linear-gradient(120deg, rgba(85,140,255,0.92), rgba(65,170,250,0.9), rgba(40,110,220,0.9)), url('/ChatGPT%20Image%20Nov%2025,%202025,%2008_20_11%20PM.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-black/10" />
            <div className="relative px-10 pt-8 pb-10 flex flex-col gap-6 flex-1 text-white">
              <div className="flex flex-wrap gap-2 justify-center">
                {chipsRight.map((chip, idx) => (
                  <span
                    key={idx}
                    className="text-xs text-white bg-white/15 border border-white/20 px-3 py-1 rounded-lg tracking-tight"
                  >
                    {chip}
                  </span>
                ))}
              </div>
              <div className="flex-1 flex flex-col items-center gap-4">
                <h3 className="text-white text-4xl md:text-5xl font-light leading-tight text-center">
                  Bear Strategy Lab
                </h3>
                <p className="text-white text-base leading-relaxed text-center">
                  We use plain language, deliver in weeks, and build systems that work from day one—with you involved at every step.
                </p>
                <div className="w-full flex justify-center">
                  <ul className="text-sm text-white/90 space-y-1.5 text-left max-w-sm">
                    <li>• Clear timelines, frequent check-ins</li>
                    <li>• Transparent scope and pricing</li>
                    <li>• Collaborative rollouts and ongoing support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
